import React from "react";

import { theme } from "../../style/theme";
import { useApp } from "../../contexts/app";
import { Hex } from "../../game/mechanics";
import {
  hexRenderPosition,
  hexPolygonPoints,
  sideLength,
  hexratio,
  paddingViewport,
  cube2cartesian,
} from "../../game/geometry";

export const PreviewPlacement = ({
  hex,
  transform,
}: {
  hex: Hex;
  transform: {
    scale: number;
    min: { x: number; y: number };
    offsetInDiv: { X: number; Y: number };
  };
}) => {
  const {
    state: { game },
    movePiece,
  } = useApp();

  const { width, height, top, left } = hexRenderPosition({
    coords: cube2cartesian(hex),
    transform,
  });

  const hside = hexratio;
  const vside = sideLength;
  const p = paddingViewport;

  const handleClick = () => {
    console.log("executing handleClick");
    if (game.action.placing) {
      movePiece({ type: "place", hex, justPlaced: game.action.placing });
    } else if (game.action.moving) {
      movePiece({ type: "move", to: hex });
    }
  };

  return (
    <div
      style={{
        width: `${width}px`,
        height: `${height}px`,
        left,
        top,
        position: "absolute",
        pointerEvents: "none",
      }}
    >
      <svg
        className="pointer-events-none"
        width="100%"
        height="100%"
        viewBox={`${-hside - p} ${-vside - p} ${2 * (hside + p)} ${
          2 * (vside + p)
        }`}
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        // onTouchStart={() => {
        //   console.log("onTouchStart");
        //   handleClick();
        // }}
        onClick={() => {
          console.log("clicked on PreviewPlacement");
          handleClick();
        }}
      >
        <polygon
          className="preview-placement pointer-events-all"
          points={hexPolygonPoints}
          strokeWidth={theme.board.piece.stroke.width}
          strokeDasharray={0.1}
        />
      </svg>
    </div>
  );
};
